import { Navigate, useParams } from "react-router";
import { useElectricityTable } from "@/api/districts";
import { getElectricityColumns } from "@/components/meters/meter-columns";
import { GenericMeterTab } from "@/components/meters/meter-tab";
import { useTableUrlState } from "@/components/table/use-table-url-state";
import { isValidLang, ROUTE_SLUGS } from "@/config/routes";
import { useDistrict } from "@/contexts/district-context";
import { useHideElectricity } from "@/hooks/use-hide-electricity";

export function ElectricityMetersPage() {
	const { lang } = useParams<{ lang: string }>();
	const currentLang = lang && isValidLang(lang) ? lang : "pl";
	const hideElectricity = useHideElectricity();
	const { districtId } = useDistrict();
	const {
		page,
		pageSize,
		search,
		ordering,
		setPage,
		setPageSize,
		setSearch,
		setOrdering,
	} = useTableUrlState("-last_reading_date");

	if (hideElectricity) {
		return (
			<Navigate
				to={`/${currentLang}/${ROUTE_SLUGS.waterMeters[currentLang]}`}
				replace
			/>
		);
	}

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			<GenericMeterTab
				page={page}
				pageSize={pageSize}
				setPage={setPage}
				setPageSize={setPageSize}
				search={search}
				setSearch={setSearch}
				ordering={ordering}
				setOrdering={setOrdering}
				getColumns={getElectricityColumns}
				useTableQuery={useElectricityTable}
				districtId={districtId}
			/>
		</div>
	);
}
